import { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import TicketDetail from "./TicketDetail";
import Answer from "./Answer";
import { BaseURL } from "../../config/axios";
import { useNavigate, useSearchParams } from "react-router-dom";

const Ticket = ({ setOnTicket, role, status }) => {
    const { AxiosPrivate } = useAxios()

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const ticketId = searchParams.get('ticket');
    const queries = Object.fromEntries([...searchParams.entries()].filter(([key]) => key !== 'ticket'));

    const [ticket, setTicket] = useState({})

    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (ticketId) {
            const get = async () => {
                await AxiosPrivate.get(`/ticket/${role}-show/${ticketId}`)
                    .then(res => setTicket(res.data.data))
                    .catch(err => alert(err.response?.data.message))
                    .finally(() => setLoading(false))
            }
            get()
        }
    }, [ticketId])


    const Tickets = () => {
        setOnTicket()
        const newParams = new URLSearchParams(queries);
        navigate({ pathname: window.location.pathname, search: `?${newParams.toString()}` }, { replace: true });
    }

    const handleDelete = async () => {
        if (window.confirm('آیا از حذف تیکت اطمینان دارید؟'))
            await AxiosPrivate.delete(`/ticket/delete/${ticketId}`)
                .then(res => {
                    alert(res.data.message)
                })
                .catch(err => alert(err.response?.data.message))

    }
    return (
        <>

            <div className='border rounded-lg' dir='rtl'>
                <div className='flex flex-col gap-3'>
                    <div className='flex items-center gap-4 border-b p-6'>
                        <button className='centerOfParent bg-none border-none outline-none' onClick={Tickets}><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"></path></svg></button>
                        <div className='flex items-center gap-1.5'>
                            <p>جزئیات تیکت</p>
                        </div>
                    </div>
                    {!loading ?
                        <div className="p-4">
                            <TicketDetail user={ticket.user || null} date={ticket.created_at} subject={ticket.subject} message={ticket.message} admin_reply={ticket.admin_reply} contact={ticket.mobile} img={ticket.images[0] ? BaseURL + ticket.images[0].path : null} />
                            {!!ticket.user && (status == 'new' || status == 'read') && <Answer />}
                            {!ticket.user && <button onClick={handleDelete} type="button" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:outline-none shadow-lg shadow-blue-500/50 dark:shadow-lg dark:shadow-blue-800/80 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 my-3 w-fit">حذف</button>}
                        </div>
                        : <div className="w-full centerOfParent">درحال بارگزاری ...</div>}
                </div>
            </div>
        </>
    );
};

export default Ticket;